/* loading-mojo.module.css */
.full {
  position: absolute;
  inset: 0;
  margin: auto;
  z-index: 100; /* Consider using a CSS variable like --z-index-loading or similar if available */
}

.border {
  box-shadow: var(--shadow-raised);
  border-radius: var(--radius-lg);
  padding: var(--spacing-lg);
  background-color: var(--surface-default);
}

.inline {
  display: inline-block;
}

.block {
  display: block;
  margin-bottom: var(--spacing-sm);
}

.greyout {
  position: absolute;
  inset: 0;
  background-color: var(--surface-default);
  opacity: 0.4;
  z-index: 100;
}

/* Styles for the inline version with text */
.inlineTextLayout {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
}

.inlineImageWrapper {
  flex: 0 0 auto;
  margin-right: var(--spacing-sm);
  align-self: center;
}

.inlineTextContent {
  flex: 1 0 0px;
  align-self: center;
}

/* Utility class for accessible hidden text */
.visuallyHidden {
  position: absolute;
  color: transparent;

  /* Fallback for older screen readers, though 'color: transparent' is often enough */
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap; /* added line */
  border: 0;
}
